import { DotOutline, Check } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';

import {
  RequirementItemStyled,
  RequirementItemIconStyled,
  RequirementItemTextStyled,
} from './PasswordRequirementItemStyled';

interface PasswordRequirementProps {
  text: string;
  valid: boolean;
}

export const PasswordRequirementItem = ({
  text,
  valid,
}: PasswordRequirementProps) => {
  const { t } = useTranslation('pages.changePassword');
  return (
    <RequirementItemStyled data-testid="password-requirement-item">
      <RequirementItemIconStyled>
        {valid ? (
          <Check size={32} weight="light" color="#4caf50" />
        ) : (
          <DotOutline size={32} weight="fill" />
        )}
      </RequirementItemIconStyled>
      <RequirementItemTextStyled
        primaryTypographyProps={{
          variant: 'body2',
          color: valid ? '#4caf50' : '#000000',
        }}
        primary={t(text)}
      />
    </RequirementItemStyled>
  );
};
